__turbopack_context__.v({
  "className": "montserrat_21218cfe-module__99C0aq__className",
  "variable": "montserrat_21218cfe-module__99C0aq__variable",
});
